import { globalGetService } from '@/utils/globalApiServices';
import { getFilenameFromContentDisposition } from '@/utils/file';
import {
  BrandSuggestionParams,
  BrandSuggestion,
  Brand,
  BrandDetail,
  BrandVettingRecord,
  BrandTrademark,
  BrandSenderId,
  BrandLOA,
} from './types';
import { Pagination } from '@/utils/types';

export const getBrandSuggestions = async (
  queries: BrandSuggestionParams = {}
): Promise<BrandSuggestion[]> => {
  const response = await globalGetService('mno/brands/suggestions', queries);
  return response?.ok ? response.data : [];
};

export const getBrands = async (queries?: Record<string, any>) => {
  const response = await globalGetService('mno/brands', queries);
  return response?.ok ? (response.data as Pagination<Brand>) : undefined;
};

export const getBrand = async (brandUid: string) => {
  const response = await globalGetService(`mno/brands/${brandUid}`);
  return response?.ok ? (response.data as BrandDetail) : undefined;
};

export const getBrandAssets = async (
  brandUid: string,
  params?: { verificationStatus?: string }
) => {
  const response = await globalGetService(
    `mno/brands/${brandUid}/assets`,
    params
  );
  return response?.ok ? response.data : [];
};

export const getSenderIDs = async (brandUid: string) => {
  const response = await globalGetService<BrandSenderId[]>(
    `mno/brands/${brandUid}/senderIds`
  );
  return response?.ok ? response.data : [];
};

export const getLOAs = async (brandUid: string) => {
  const response = await globalGetService<BrandLOA[]>(
    `mno/brands/${brandUid}/LOA`
  );
  return response?.ok ? response.data : [];
};

export const getLoaDoc = async (
  brandUid: string,
  docUid: string,
  params?: { format?: string }
) => {
  const isPdf = params?.format === 'pdf';
  const response = await globalGetService(
    `mno/brands/${brandUid}/LOA/${docUid}`,
    params,
    isPdf ? { responseType: 'arraybuffer' } : undefined
  );

  if (response?.ok) {
    const filename = getFilenameFromContentDisposition(
      response.headers?.['content-disposition'],
      'LOA.pdf'
    );
    return {
      data: response.data,
      filename,
    };
  }
  return undefined;
};

export const getVettings = async (
  brandUid: string,
  params?: { vettingStatus?: string }
) => {
  const response = await globalGetService<BrandVettingRecord[]>(
    `mno/brands/${brandUid}/vettings`,
    params
  );
  return response?.ok ? response.data : [];
};

export const getTrademarks = async (brandUid: string) => {
  const response = await globalGetService<BrandTrademark[]>(
    `mno/brands/${brandUid}/trademarks`
  );
  return response?.ok ? response.data : [];
};
